import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React, { useContext, useEffect, useState } from "react";
import LangChangeButton from "../../../languages/LangChangeButton";
import { HeaderContainer } from "./styled";
import { Box, ButtonStyled, LazyImage } from "../../styled/Elements";
import { LogoAr, LogoEn, Logout } from "../../styled/AllImages";
import { Logo } from "../../styled/AllImages";
import Login from "../../../pages/auth/login/Login";
import { AuthContext } from "../../../context/authContext";
import LogoutModal from "../Modal/LogoutModal";
import AuthApi from "../../../services/api/authApi";
import { toast } from "react-toastify";

const AuthHeader = ({ headerBg }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);
  const hasLoginInLocation = location.pathname.includes("login");
  //   const [isLoading, setIsLoading] = useState(false);
  //   const [showLogout, setShowLogout] = useState(false);

  //   const handleLogout = async () => {
  //     try {
  //       setIsLoading(true);
  //       const response = await AuthApi.logout();
  //       if (response.code === 200) {
  //         toast.success(response.message);
  //         logout();
  //         setShowLogout(false);
  //       }
  //       if (response.code === 100 || response.code === 204) {
  //         toast.error(response.message);
  //       }
  //     } catch (error) {
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleNavigation = () => {
    if (isAuthenticated && location.pathname.includes("profile/")) {
      navigate("/my-profile");
    } else {
      navigate("/");
    }
  };

  return (
    <Box>
      <HeaderContainer>
        <Box
          className={`header-container ${headerBg ? "whiteBg" : ""} ${
            isSticky ? "sticky" : ""
          }`}
        >
          <Box className="nav-bar">
            {/* <Box className="logo">
              <Logo />
            </Box> */}
            <Box className="logo" onClick={handleNavigation}>
              <Logo />
            </Box>
            <Box className="whtLngWrapper d-flex align-items-center justify-content-center">
              {location.pathname.includes("/profile/") && (
                <ButtonStyled
                  label={t("visit_home")}
                  bg="var(--white)"
                  border="var(--themeColorSecondary)"
                  radius="10px"
                  color="var(--themeColorSecondary)"
                  className="px-2 px-sm-3"
                  onClick={() => window.open("/", "_blank")}
                />
              )}
              <LangChangeButton />
              {location.pathname === "/login" && (
                <ButtonStyled
                  label={t("sign_up")}
                  color="var(--white)"
                  bg="var(--themeColorSecondary)"
                  // clName={"signup-btn"}
                  className={""}
                  size="16px"
                  padding="11px 20px"
                  onClick={() => navigate("/signup")}
                />
              )}
              {(location.pathname === "/reset-password" ||
                location.pathname.includes("/profile/")) &&
                (isAuthenticated ? (
                  <ButtonStyled
                    label={t("my_profile")}
                    color="var(--white)"
                    bg="var(--themeColorSecondary)"
                    className={"px-2 px-sm-3"}
                    size="16px"
                    padding="11px 20px"
                    onClick={() => navigate("/my-profile")}
                  />
                ) : (
                  <ButtonStyled
                    label={t("login")}
                    color="var(--white)"
                    bg="var(--themeColorSecondary)"
                    className={"px-2 px-sm-3"}
                    size="16px"
                    padding="11px 20px"
                    onClick={() => navigate("/login")}
                  />
                ))}
              {/* {["/registration", "/under-review", "/profile-rejected"].includes(
                location.pathname
              ) &&
                isAuthenticated && (
                  <ButtonStyled
                    label={t("Logout")}
                    color="var(--white)"
                    bg="var(--themeColorSecondary)"
                    clName={"signup-btn"}
                    className={""}
                    size="16px"
                    padding="11px 20px"
                    onClick={() => setShowLogout(true)}
                    icon={Logout}
                  />
                )} */}
            </Box>
          </Box>
        </Box>
      </HeaderContainer>

      {/* <LogoutModal
        show={showLogout}
        onHide={() => setShowLogout(false)}
        handleLogout={handleLogout}
        isLoading={isLoading}
      /> */}
    </Box>
  );
};

export default AuthHeader;
